import type { Winner } from '@src/@types/ozonPrizeWinners';
import { WINNER_LIST_ANCHOR } from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/constants';
import { WinnerItem } from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/OtherWinners/components/WinnerItem';

import styles from './styles.module.scss';

type Props = {
  items: Winner[];
};

export const OtherWinners = ({ items }: Props) => (
  <div id={WINNER_LIST_ANCHOR} className={styles.container}>
    {items.map((winner, index) => (
      <WinnerItem key={winner.id} winner={winner} isLast={index === items.length - 1} />
    ))}
  </div>
);
